<template>
  <div>
    <b-modal
      id="modal-payment-qr"
      v-model="dialog"
      centered
      hide-header
      no-close-on-backdrop
      @hidden="hideModalUpdateHole"
    >
      <b-card-header class="banned-background-color-primary">
        <div class="d-flex justify-content-between align-items-center block-header">
          <div class="d-flex justify-content-start align-items-center">
            <p class="mb-0 title-modal color-primary mr-1">
              {{ $t('golf_booking_payment_qr') }} : {{ orderInfo }}
            </p>
          </div>
          <feather-icon
            icon="XIcon"
            size="24"
            class="cursor-pointer color-primary"
            @click="hideModalUpdateHole"
          />
        </div>
      </b-card-header>
      <b-card-body class="d-flex justify-content-center align-items-center flex-column">
           <p class="mb-0 content-body-modal d-flex align-items-center">
    {{ $t('golf_booking_payment_qr_time')  }}:
    <span class="ml-1 text-danger"> {{ formattedCountdown }}</span>
  </p>
    <img :src="qrImage" alt="QR Code" style="width:250px; height:250px;">
     <div v-if="(BookingType ==='COURSE' && checkPermission('ICEP03A')) || (BookingType ==='DRIVINGRANGE' && checkPermission('ICEP03B') ) || (BookingType ==='RETAIL' && checkPermission('ICEP03C')) "  
     
     class="col-lg-12">
              <div class="form-group">
                <label>{{ $t('golf_booking_payment_qr') }}</label>
                <b-form-group>
                  <b-form-input
                    :placeholder="$t('golf_booking_payment_qr')"
                    v-model="orderInfoUpdate"
                  />
                </b-form-group>
              </div>
            </div>
      </b-card-body>
      <template #modal-footer>
        <div class="w-100">
          <b-button
            size="md"
            class="float-right ml-1"
            @click="hideModalUpdateHole"
          >
          {{ $t('golf_common_back') }}
          </b-button>
          <b-button
            variant="primary"
            size="md"
            class="float-right  ml-1"
            @click="printQR"
          >
            {{ $t('golf_booking_payment_qr_print') }}
          </b-button>

          <b-button
          variant="primary"
          class="float-right"
          :disabled="disableButton || loading"
          v-if="(BookingType ==='COURSE' && checkPermission('ICEP03A')) || (BookingType ==='DRIVINGRANGE' && checkPermission('ICEP03B') ) || (BookingType ==='RETAIL' && checkPermission('ICEP03C')) "  
            @click="UpdatePaymentByOrderInfo"
          >
             <b-spinner small v-if="loading" class="mr-2"></b-spinner>
              {{ $t('golf_payment_add_payment') }}
           </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import 'vue-slider-component/theme/antd.css'
import VueSlider from 'vue-slider-component'
import ShortKey from '@/views/modules/ultils/ShortKey'
import {F1,F2,F3,F4,F5,F6,F7,F8,F9,F10,F11,F12,A,F,S} from '@/api/constant.js'
// import {
//   BTableSimple, BTable, BCardHeader, BFormGroup, BFormInput, BModal, BCardBody, BForm, BRow, BCol, BFormTextarea,
//   BThead, BTr, BTh, BTd, BTbody, BFormCheckbox
// } from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import vSelect from 'vue-select'
import { booking } from '@/api/booking'
import { config } from '@/api/config-setting'
import dayjs from 'dayjs'
import { getCurrentDateUTC } from '@/@core/utils/utils'

export default {
  name: 'PaymentQR',
  components: {
    // BModal, BCardHeader, BFormInput, BFormGroup, BCardBody, BForm,  ValidationProvider, ValidationObserver,
    // BRow, BCol, BFormTextarea, BTable, BTableSimple, BThead, BTr, BTh, BTd, BTbody, BFormCheckbox,
    vSelect, VueSlider,ShortKey
  },
  props: [
    'base64QR', 'EzpDate','orderInfo',,'BookingType','PaymentId'
  ],
  data() {
    return {
      packages: {
        list: [],
      },
      selected: [],
      reason: {
        list: [],
        selected: null,
      },
      isIncludedTax: true,
      isFreeTax: true,
      orderInfoUpdate :null,
      disableButton : true,
      dialog: false,
          countdown: 600, // 10 phút = 600 giây
          countdownEnd: 0, // 10 phút = 600 giây
    countdownTimer: null,
    apiInterval: null, // <-- thêm biến này để lưu interval gọi API
    loading: false,
      allChildComponentClosed: [ ],
      ShortCutKey : [F1,F2,F3,F4,F5,F6,F7,F8,F9,F10,F11,F12,A,F,S]
    }
  },
  created(){
     //this.map()
     //this.onChangeClient()
  },
  computed: {
    fieldstbl() {
      return [
      ]
    },
    qrImage() {
      // Định dạng chuẩn data URL cho PNG
      return `data:image/png;base64,${this.base64QR}`;
    },
    formattedCountdown() {
    const minutes = String(Math.floor(this.countdown / 60)).padStart(2, '0');
    const seconds = String(this.countdown % 60).padStart(2, '0');
    return `${minutes}:${seconds}`;
  }
  },
  watch: {
   
    dialog(val) {
      if(val === true) {
       this.open()
      } else {
        //this.hideModalUpdateHole()
      }
      
    },
    orderInfoUpdate(value) {
      if (value != null && value.trim() !== "") {
        this.disableButton = false;
      } else {
        this.disableButton = true;
      }
    },

  },
  async mounted() {},
  methods: {
    open() {
      // if (!this.checkPermission('UBK04')) {
      //   return
      // }
      this.dialog = true
      this.orderInfoUpdate = null
      this.startCountdown();
      
     
    },
    doubleRaf(callback) {
      requestAnimationFrame(() => {
        requestAnimationFrame(callback)
      })
    },
    hideModalUpdateHole() {
      this.dialog = false
      this.stopCountdown();
    },
    
    onTriggeredEventHandler(payload) {
      if (payload.evt.ctrlKey && payload.key === S) {
      }
    },
startCountdown() {
  const endTime = new Date(this.EzpDate).getTime();

  this.stopCountdown(); // clear nếu đã có timer trước đó
  let tick = 0; // để xác định thời điểm gọi API (2s/lần)

  this.countdownTimer = setInterval(async () => {
    const now = new Date(this.getCurrentDateUTC()).getTime();
    this.countdown = Math.max(Math.floor((endTime - now) / 1000), 0);

    if (this.countdown <= 0) {
      this.hideModalUpdateHole();
      this.stopCountdown();
      return;
    }

    // Cứ mỗi 2 giây thì gọi API 1 lần
    if (tick % 2 === 0) {
      try {
        const res = await config.API_EzPayment_RCEP02({ orderInfo: this.orderInfo });
        if (res.Status === '200') {
          this.hideModalUpdateHole();
          this.$emit('event');
          this.stopCountdown(); // Dừng khi thành công
          return;
        }
      } catch (error) {
        // handle error nếu cần
      }
    }

    tick++;
  }, 1000);
},
  stopCountdown() {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
      this.countdownTimer = null;
      
    }
    if(this.apiInterval) {
      clearInterval(this.apiInterval);
      this.apiInterval = null;
    }
  },
  printQR() {
    const printWindow = window.open('', '', 'width=600,height=500');
    printWindow.document.write(`
      <html>
        <head>
          <title>QR Code</title>
          <style>
            body { display: flex; justify-content: center; align-items: center; flex-direction: column; font-family: Arial, sans-serif; padding: 20px; }
            h3 { color: #114A9F; }
            img { width: 50px; height: 50px; margin-top: 10px; }
          </style>
        </head>
        <body>
          <img src="${this.qrImage}" alt="QR Code" />
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  },
  async UpdatePaymentByOrderInfo() {
    try {
      this.loading = true;
      // Thêm logic xử lý cập nhật payment ở đây
      // Ví dụ: await api.updatePayment({ orderInfo: this.orderInfoUpdate });
      const res = await config.API_EzPayment_ICEP03({ 
        orderInfo: this.orderInfoUpdate,
        BookingType: this.BookingType,
        PaymentId : this.PaymentId,

      });
      this.showResToast(res)
      if (res.Status === '200') {
      this.hideModalUpdateHole();
      this.$emit('event')
      // Dừng luôn khi API trả thành công
      }
      
    } catch (error) {
      
    } finally {
      this.loading = false;
    }
  }
  },
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/variables/variables';
@import '@core/scss/vue/libs/vue-slider.scss';
::v-deep {
  .modal-content {
    background: #FFFFFF;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
    border-radius: 6px;
    min-width: 400px !important;
    min-height: 400px !important;
  }
  .b-table-sticky-header {
    overflow-y: auto !important;
    max-height: 85% !important;
  }
}
.banned-background-color-primary {
  background: rgba(17, 74, 159, 0.12);
}
.title-modal {
  font-style: normal !important;
  font-weight: 500 !important;
  font-size: 13px !important;
  color: #114A9F !important;
  line-height: 20px !important;
}
.content-body-modal {
  font-style: normal !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  line-height: 18px !important;
}
.color-primary {
  color: $primary;
}
.form-group-einvoice{
  width: 250px !important;
}
.span-group-einvoice{
  margin-right: 20px !important;
  width: 100px !important;
  .span-text-einvoice{
    margin-top: 9px !important;
  }
}
</style>
